import { baseApi } from "./baseApi"
import type { Player, PlayerCreatePayload, PlayerUpdatePayload } from "../../types/players"
import type { TableQueryParams } from "../../types/api"
import { withTableQuery } from "./queryParams"

export const playersApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPlayers: build.query<Player[], TableQueryParams | void>({
      query: (params) => withTableQuery("/users", params || undefined),
      providesTags: (result) =>
        result
          ? [...result.map((row) => ({ type: "Player" as const, id: row.id })), { type: "Player", id: "LIST" }]
          : [{ type: "Player", id: "LIST" }],
    }),
    getPlayer: build.query<Player, string>({
      query: (id) => `/users/${id}`,
      providesTags: (_res, _err, id) => [{ type: "Player", id }],
    }),
    createPlayer: build.mutation<Player, PlayerCreatePayload>({
      query: (body) => ({ url: "/users", method: "POST", body }),
      invalidatesTags: [{ type: "Player", id: "LIST" }],
    }),
    updatePlayer: build.mutation<Player, PlayerUpdatePayload>({
      query: ({ id, ...body }) => ({ url: `/users/${id}`, method: "PUT", body }),
      invalidatesTags: (_res, _err, arg) => [
        { type: "Player", id: arg.id },
        { type: "Player", id: "LIST" },
      ],
    }),
    deletePlayer: build.mutation<void, string>({
      query: (id) => ({ url: `/users/${id}`, method: "DELETE" }),
      invalidatesTags: (_res, _err, id) => [
        { type: "Player", id },
        { type: "Player", id: "LIST" },
      ],
    }),
  }),
})

export const {
  useGetPlayersQuery,
  useGetPlayerQuery,
  useCreatePlayerMutation,
  useUpdatePlayerMutation,
  useDeletePlayerMutation,
} = playersApi
